import moment from "moment";
import thousands from "thousands";

export const calculateDiscount = (
  data,
  numberOfTickets,
  type = "event",
  isAuthenticated
) => {
  const pricing =
    type === "form"
      ? data?.formPricing
      : type === "school"
      ? data?.class_pricing
      : data?.eventPricing;
  const discount =
    type === "form"
      ? data?.formDiscount
      : type === "school"
      ? data?.class_discount
      : data?.eventDiscount;
  const allTicketsAmount = pricing?.total_to_pay * numberOfTickets.length;
  let discountAmount = 0;
  const dataforEach = discount?.forEach((item) => {
    if (item?.forMemberOnly && !isAuthenticated) return;
    if (item?.discount_type === "date") {
      const endDate = moment(item?.end_date).format("MM/DD/YYYY");
      const startDate = moment(item?.start_date).format("MM/DD/YYYY");
      const currentDate = moment(new Date()).format("MM/DD/YYYY");

      if (startDate <= currentDate && endDate >= currentDate) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount =
            (allTicketsAmount * item?.value) / 100 + discountAmount;
        }
      } else {
      }
    } else if (
      item?.discount_type === "amount" &&
      allTicketsAmount >= item?.amount
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount =
          (allTicketsAmount * item?.value) / 100 + discountAmount;
      }
    } else if (
      item?.discount_type === "quantity" &&
      item?.quantity &&
      numberOfTickets?.length >= item?.quantity
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount =
          (allTicketsAmount * item?.value) / 100 + discountAmount;
      }
    }
  });

  const totalAfterDiscount =
    allTicketsAmount > 0
      ? (+allTicketsAmount - +discountAmount).toFixed(2)
      : "0.00";
  return {
    totalAfterDiscount,
    discountTotal:
      discountAmount < 0
        ? `-$${Math.abs(discountAmount).toFixed(2)}`
        : `-$${discountAmount.toFixed(2)}`,
    totalDiscount: discountAmount,
  };
};
export const calculateTotalPayment = (
  data,
  numberOfTickets,
  type,
  isAuthenticated
) => {
  const totalPayment = calculateDiscount(
    data,
    numberOfTickets,
    type,
    isAuthenticated
  )?.totalAfterDiscount?.replace(/,/g, "");
  return (+totalPayment).toFixed(2);
};

export const calculateTotalPaymentWithCVFee = (
  data,
  numberOfTickets,
  type,
  isAuthenticated
) => {
  const totalPayment = calculateDiscount(
    data,
    numberOfTickets,
    type,
    isAuthenticated
  )?.totalAfterDiscount?.replace(/,/g, "");
  return (+totalPayment).toFixed(2);
};

export const calculateDueDiscount = (
  totalAmount,
  discounts,
  numberOfTickets,
  isAuthenticated
) => {
  let discountAmount = 0;

  const dataforEach = discounts?.forEach((item) => {
    if (item?.forMemberOnly && !isAuthenticated) return;
    if (item?.discount_type === "date") {
      const endDate = moment(item?.end_date).format("MM/DD/YYYY");
      const startDate = moment(item?.start_date).format("MM/DD/YYYY");
      const currentDate = moment(new Date()).format("MM/DD/YYYY");

      if (startDate <= currentDate && endDate >= currentDate) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
        }
      } else {
      }
    } else if (
      item?.discount_type === "amount" &&
      totalAmount >= item?.amount
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
      }
    } else if (
      item?.discount_type === "quantity" &&
      item?.quantity &&
      numberOfTickets?.length >= item?.quantity
    ) {
      if (item?.price_type === "fixed") {
        discountAmount += item?.value;
      } else {
        discountAmount = (totalAmount * item?.value) / 100 + discountAmount;
      }
    }
  });

  const totalAfterDiscount =
    totalAmount > 0 ? +totalAmount - +discountAmount : 0;
  return {
    totalAfterDiscount,
    discountTotal: discountAmount,
  };
};

export const calculateBulkClassesDiscount = (classes, isAuthenticated) => {
  let totalDiscount = 0;
  const classesdata = classes?.forEach((classItem) => {
    const pricing = classItem?.class_pricing;
    const discount = classItem?.class_discount;
    const allTicketsAmount = pricing?.total_to_pay;
    let discountAmount = 0;

    const discountdata = discount?.forEach((item) => {
      if (item?.forMemberOnly && !isAuthenticated) return;
      if (item?.discount_type === "date") {
        const endDate = moment(item?.end_date).format("MM/DD/YYYY");
        const startDate = moment(item?.start_date).format("MM/DD/YYYY");
        const currentDate = moment(new Date()).format("MM/DD/YYYY");

        if (startDate <= currentDate && endDate >= currentDate) {
          if (item?.price_type === "fixed") {
            discountAmount += item?.value;
          } else {
            discountAmount =
              (allTicketsAmount * item?.value) / 100 + discountAmount;
          }
        } else {
        }
      } else if (
        item?.discount_type === "amount" &&
        allTicketsAmount >= item?.amount
      ) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount =
            (allTicketsAmount * item?.value) / 100 + discountAmount;
        }
      } else if (
        item?.discount_type === "quantity" &&
        item?.quantity &&
        classItem?.selectedClassesList?.length >= item?.quantity
      ) {
        if (item?.price_type === "fixed") {
          discountAmount += item?.value;
        } else {
          discountAmount =
            (allTicketsAmount * item?.value) / 100 + discountAmount;
        }
      }
    });

    totalDiscount += discountAmount;
  });
  return {
    totalDiscount: totalDiscount,
  };
};

export const calculateBulkClassesAmount = (classes, isAuthenticated) => {
  let totalAmount = 0;

  for (const classItem of classes) {
    const { totalPercentage, totalFixed } = calculateTotalDiscount(
      classItem,
      isAuthenticated,
      classes?.length
    );

    // Calculate without installments for bulk classes amount
    const { totalAmountAll } = calculateTotalAmount(
      classItem,
      false,
      totalFixed,
      totalPercentage
    );

    totalAmount += totalAmountAll;
  }

  return totalAmount;
};

export const calculateBulkClassesDueAmount = (classes, isAuthenticated) => {
  let totalAmount = 0;

  for (const classItem of classes) {
    const { totalPercentage, totalFixed } = calculateTotalDiscount(
      classItem,
      isAuthenticated,
      classes?.length
    );

    // Calculate with installments for due amount
    const { totalAmountAll } = calculateTotalAmount(
      classItem,
      true,
      totalFixed,
      totalPercentage
    );

    totalAmount += totalAmountAll;
  }

  return totalAmount;
};

export const calculateClassesAmount = (
  classItem,
  isAuthenticated,
  numberOfTickets
) => {
  const { totalPercentage, totalFixed } = calculateTotalDiscount(
    classItem,
    isAuthenticated,
    numberOfTickets
  );

  // Calculate without installments for class amount
  const { totalAmountAll, totalDiscountAmount } = calculateTotalAmount(
    classItem,
    false,
    totalFixed,
    totalPercentage
  );

  return { totalAmountAll, totalDiscountAmount };
};

const calculateTotalDiscount = (classInfo, isMember, numberOfTicket) => {
  let totalPercentage = 0;
  let totalFixed = 0;
  const newDate = new Date();

  if (classInfo?.class_discount?.length) {
    const discountsList = classInfo?.class_discount?.map((item) => {
      if (
        item?.discount_type === "date" &&
        newDate >= new Date(moment(item?.start_date).startOf("day")) &&
        newDate <= new Date(moment(item?.end_date).endOf("day"))
      ) {
        if (item.forMemberOnly && !isMember) return item;
        if (item.price_type === "percentage") {
          totalPercentage += item?.value;
        } else {
          totalFixed += item?.value;
        }
        return item;
      }
      if (item?.discount_type === "amount") {
        if (item.forMemberOnly && !isMember) return item;
        if (item.price_type === "percentage") {
          totalPercentage += item?.value;
        } else {
          totalFixed += item?.value;
        }
        return item;
      }
      if (item?.discount_type === "quantity" && numberOfTicket > 1) {
        if (item.forMemberOnly && !isMember) return item;
        if (item.price_type === "percentage") {
          totalPercentage += item?.value;
        } else {
          totalFixed += item?.value;
        }
        return item;
      }

      return item;
    });
  }

  return { totalPercentage, totalFixed };
};

const calculateTotalAmount = (
  classInfo,
  withInstallments = false,
  totalFixedBulk,
  totalPercentageBulk
) => {
  let totalAmount = 0;
  let totalDiscountAmount = 0;
  const transactionDetails = classInfo?.class_pricing?.prices?.filter(
    (item) => {
      return item.type === "onRegistration";
    }
  );

  let totalPercentage = totalPercentageBulk ? totalPercentageBulk / 100 : 0;

  let totalAmountBeforeDiscount = 0;
  transactionDetails.map((item) => {
    totalAmountBeforeDiscount += item.amount;
    return item;
  });

  if (totalFixedBulk) {
    const convertFixed = totalFixedBulk / totalAmountBeforeDiscount;
    totalPercentage += convertFixed;
  }

  transactionDetails.map((item) => {
    let originalAmount = item?.amount;
    let amount = originalAmount;
    let itemDiscountAmount = 0;

    // Apply discount if any
    if (totalPercentage > 0) {
      itemDiscountAmount = originalAmount * totalPercentage;
      amount *= 1 - totalPercentage;
    }

    // Check if item has installment enabled and installment value
    if (
      withInstallments &&
      item?.installmentStatus &&
      item?.installment?.value
    ) {
      // Use installmentDetailsTransaction if available, otherwise use installment.value
      const numberOfInstallments = item?.installment?.value;

      if (numberOfInstallments > 1) {
        amount = Number((amount / numberOfInstallments).toFixed(2));
      }
    }

    totalAmount += amount;
    totalDiscountAmount += itemDiscountAmount;
    return item;
  });

  return {
    totalAmountAll: totalAmount,
    totalPercentageAll: totalPercentage,
    totalDiscountAmount,
  };
};
